<style>
	.bg343 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 1s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar5{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%; }
.tabbar5 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar5 span.pos{  padding:0 1vw;}
.tabbar5 span.floder{ color:#666;}
 
.tabbar5 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}

.interact_right{width:64vw;height: 45vw;background-color: #fffff9;margin: 0;padding: 0;overflow: hidden;margin-top:6vw;float: left;
border: #e3e3e3 solid 1px;box-sizing: border-box; border-left: 0;} 
.interact_right input.h_title{width: 60vw;margin: 0 auto;height: 5vw;display: block;border: 0;border-bottom: #ddd solid 1px;border-radius: 0;
font-size: 1.6vw;color: #3465ff;}
.interact_right input.h_title::placeholder{color: #3465ff;}
.liu_box{width: 60vw;height: 13.2vw;border-bottom: #ddd solid 1px;}
.liu_head{width: 100%;height: 5vw;border-bottom: #ddd solid 1px;}
.liu_head span{display: block;line-height: 5vw;color: #000;font-size: 1.2vw;font-weight: bold;}
.liu_head span.liu1{float: left;}
.liu_head span.liu2{float: left;margin-left: 2vw;}
.liu_head span.liu3{float: right;}
.liu_head span.liu4{float: right;padding-left: 2vw;color: #3465ff;}
.liu_box p{line-height: 2.3vw;color: #333;}

.interact_pages{width: 100%;height: 5vw;vertical-align: middle;text-align: center;}
.interact_pages img{width: 2vw;height: 2vw;vertical-align: middle;}
.interact_pages span{line-height: 5vw;vertical-align: middle;font-size: 1.4vw;padding: 0 1vw;font-weight: bold;}
.interact_pages span.on{color: #3465ff;}
</style>
<template>
	<div class="bg343">

         
	     <u_center></u_center>
	     <interact :main="main" :sub="sub" :title="title"></interact>
	     <div class="interact_right">
	     	<div class="liu_box">
	     		<div class="liu_head">
	     			<span class="liu1">姓名：王鹏飞</span>
	     			<span class="liu2">电话：138-0013-8000</span>
	     			<span class="liu4">删除</span>
	     			<span class="liu3">来自：天津</span>
	     		</div>
	     		<p>共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福
	     		共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福</p>
	     	</div> 
	     	<div class="liu_box">
	     		<div class="liu_head">
	     			<span class="liu1">姓名：王鹏飞</span>
	     			<span class="liu2">电话：138-0013-8000</span>
	     			<span class="liu4">删除</span>
	     			<span class="liu3">来自：天津</span>
	     		</div>
	     		<p>共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福
	     		共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福</p>
	     	</div>
	     	<div class="liu_box">
	     		<div class="liu_head">
	     			<span class="liu1">姓名：王鹏飞</span>
	     			<span class="liu2">电话：138-0013-8000</span>
	     			<span class="liu4">删除</span>
	     			<span class="liu3">来自：天津</span>
	     		</div>
	     		<p>共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福
	     		共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福共产党好共产党为人民谋幸福</p>
	     	</div>
	     	<div class="interact_pages">
	        		<img src="../../assets/images/pre2.png">
	        		<span>1</span><span>2</span><span class="on">3</span><span>4</span><span>5</span>
	        		<img src="../../assets/images/next1.png">
	        </div>
		 </div>
	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
import interact from '@/components/interact.vue'; 
	export default {
	    components: {
		  u_center,
		  interact
	    },
		data() {
			return {
				token:"",
				main:4,
				sub:"",
				title:"留言管理",
			}
		},
		mounted() {
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  
			  } 

		},
		methods: {
			vote_add(){
                   this.$router.push("/vote_add");  
			},
			 add_template(){	 
              if(!this.sign_selected){
              	  this.$toast.center('请选择签名');
              	  return;
              }
		      let self=this;
			  self.$loading('提交中...');
		      axios.post(this.$api+'/message/add_template', {
					   token:self.token,
					   type:self.type,
					   content:self.content,
					   signname:self.signname
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){
				             self.$toast.center('添加成功，请等待审核');	
                             setTimeout(function(){
								        self.$loading.close();
										self.back();
					         },1000);				  
					 		 
				  }else if(data.state==3){                
					 self.$router.push("/");  		 
				  }else{
				     self.$loading.close();
				     self.$toast.center(data.msg);	
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		},watch:{
			   content(){
			     this.current_length=  this.$refs.count.value.length; 		      
			     this.count=Math.ceil(this.current_length/70);
			   }
              
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/interact/liu.vue